<!-- Business Disabled Container -->
<div *ngIf="businessDisabled" class="business-disabled-container">
  <div class="icon-container">
    <svg class="disabled-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"/>
      <!-- X mark inside circle -->
      <path d="M8 8 L16 16 M16 8 L8 16" stroke-linecap="round"/>
    </svg>
  </div>
  
  <h1 class="disabled-title">Account Disabled</h1>
  
  <div class="message-card">
    <p class="disabled-message">
      This  account has been temporarily disabled or suspended.
    </p>
    <p class="disabled-submessage">
      Please contact Jewellers for assistance.
    </p>
  </div>
</div>

<!-- Loader -->
<div *ngIf="screenLoading && !businessDisabled" 
     style="height: 100vh; width: 100%; z-index: 1001; background-color: #ffffff;" 
     class="d-flex justify-content-center align-items-center">
  <div class="loader-screen">
    <mat-spinner></mat-spinner>
  </div>
</div>

<!-- Error screen -->
<div *ngIf="errorMessage && !screenLoading && !businessDisabled" 
     style="height: 100vh; width: 100%; z-index: 1001; background-color: #ffffff;" 
     class="d-flex flex-column justify-content-center align-items-center">
  <h2 class="text-danger">{{ errorMessage }}</h2>
</div>

<!-- Main app -->
<div *ngIf="!screenLoading && !businessDisabled && !errorMessage" class="app-shell">
  <router-outlet></router-outlet>

  <!-- Covers lazy-load + API until congratulation data is ready -->
  <div
    *ngIf="showPaymentWait"
    class="payment-wait-screen"
    [style.background]="'linear-gradient(160deg, ' + lightenColor(paymentThemeColor, 82) + ' 0%, ' + lightenColor(paymentThemeColor, 92) + ' 45%, #ffffff 100%)'">
    <div class="payment-wait-card">
      <div class="payment-wait-icon" [style.background]="lightenColor(paymentThemeColor, 88)">
        <span class="payment-wait-dot" [style.background]="paymentThemeColor"></span>
        <span class="payment-wait-dot" [style.background]="paymentThemeColor"></span>
        <span class="payment-wait-dot" [style.background]="paymentThemeColor"></span>
      </div>
      <h2 class="payment-wait-title" [style.color]="paymentThemeColor">Payments Updating</h2>
      <p class="payment-wait-message">Please wait while we confirm your payment.</p>
      <div class="payment-wait-note" [style.background]="lightenColor(paymentThemeColor, 93)">
        <img src="assets/images/home/info.svg" alt="info" />
        <p>Please do not go back or close this page until the update is complete.</p>
      </div>
    </div>
  </div>
</div>

<!-- Always mounted so Blink Checkout can invoke after CheckoutService.init -->
<paytm-checkout></paytm-checkout>